/*! PNM boot v2: ensure picker assets + sticky ?ac=1 */
(function () {
  'use strict';
  function lwmPath(p) {
    return /^\/collections\/little-wax-melts/i.test(p);
  }
  function inPicker() {
    try {
      return (
        new URLSearchParams(location.search).get('ac') === '1' &&
        lwmPath(location.pathname)
      );
    } catch (_) {
      return false;
    }
  }

  // Stick ?ac=1 while in picker mode for any LWM link
  document.addEventListener(
    'click',
    function (e) {
      if (!inPicker()) return;
      var a =
        e.target &&
        e.target.closest &&
        e.target.closest('a[href^="/collections/little-wax-melts"]');
      if (!a) return;
      try {
        var u = new URL(a.getAttribute('href'), location.origin);
        if (u.searchParams.get('ac') !== '1') {
          u.searchParams.set('ac', '1');
          a.setAttribute('href', u.pathname + '?' + u.searchParams.toString());
        }
      } catch (_) {}
    },
    true
  );

  // Ensure picker assets are loaded when in picker mode
  function ensureAssets() {
    if (!inPicker()) return;
    if (!window.__PNM_ASSETS) {
      return;
    }
    if (!document.querySelector('link[data-pnm="picker-css"]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = window.__PNM_ASSETS.pickerCss;
      l.setAttribute('data-pnm', 'picker-css');
      document.head.appendChild(l);
    }
    if (!document.querySelector('script[data-pnm="picker-js"]')) {
      var s = document.createElement('script');
      s.src = window.__PNM_ASSETS.pickerJs;
      s.defer = true;
      s.setAttribute('data-pnm', 'picker-js');
      document.head.appendChild(s);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureAssets);
  } else {
    ensureAssets();
  }
})();
